import React, { useState } from "react"
import { Container, Row } from "react-bootstrap"
import "./newsletter.scss"
import NewsletterForm from "../common/forms/newsletter"
import {graphql, useStaticQuery} from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Newsletter = ({ locale }) => {

  const [isActive, setIsActive] = useState(false)

  const handleToggle = () => {
    setIsActive(current => !current)
  }

  const data = useStaticQuery(graphql`
    query blockNewsletterQuery {
      blkNewsletterEn: blockContentBlockNewsletter(langcode: {eq: "en"}) {
        block_newsletter_title
      }
      blkNewsletterFr: blockContentBlockNewsletter(langcode: {eq: "fr"}) {
        block_newsletter_title
      }
      blkNewletterIllus: blockContentBlockNewsletter {
        relationships {
          block_newsletter_bg {
            relationships {
              field_image {
                gatsbyImage(width: 1920, formats: WEBP)
              }
            }
          }
        }
      }
    }
  `)

  // Get newsletter data by locale
  let dataNewsletter, dataNewsletterIllus
  switch (locale) {
    case "fr":
      if (data.blkNewsletterFr) {
        dataNewsletter = data.blkNewsletterFr
      }
      break
    default:
      if (data.blkNewsletterEn) {
        dataNewsletter = data.blkNewsletterEn
      }
  }
  dataNewsletterIllus = data.blkNewletterIllus

  return (
    <section className="blk-newsletter">
      <Container fluid>
        <Row className="newsletter-content">
          <div
            className={`col-md-8 col-12 animForm ${isActive ? "hideBlk" : ""}`}
          >
            <div className="newsletter-cont">
              <div className="blkIllus" onClick={handleToggle}>
                <GatsbyImage
                  image={getImage(
                    dataNewsletterIllus.relationships.block_newsletter_bg?.relationships.field_image?.gatsbyImage
                  )}
                />
              </div>
              <div>
                <h2 className="font-style_1 animTxt animTxt_2" onClick={handleToggle}>
                  <span>{dataNewsletter.block_newsletter_title}</span>
                </h2>
                {/* <div className="description animTxt animTxt_2">
                  {HTMLReactParser(dataNewsletter.block_newsletter_description.processed)}
                </div> */}
                {/*<button className="btnLink" onClick={handleToggle}>*/}
                {/*  <span>{dataNewsletter.block_newsletter_link_text}</span>*/}
                {/*</button>*/}
              </div>
            </div>
          </div>
          <div className="formContainer">
            <button
              aria-label="Close"
              className="btnClose"
              onClick={handleToggle}
            >
              <i className="icon-close"></i>
            </button>
            <NewsletterForm />
          </div>
        </Row>
      </Container>
    </section>
  )
}

export default Newsletter
